var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebbokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.61016 0 0 7.61016 0 17C0 26.3898 7.61016 34 17 34C26.3898 34 34 26.3898 34 17C34 7.61016 26.3898 0 17 0ZM20.752 14.118L20.5594 16.6613H17.9496V25.4934H14.6559V16.6613H12.8961V14.118H14.6559V12.4113C14.6559 11.6609 14.6758 10.4988 15.2203 9.775C15.798 9.01133 16.5883 8.49336 17.9496 8.49336C20.1676 8.49336 21.0973 8.81211 21.0973 8.81211L20.659 11.4152C20.659 11.4152 19.9285 11.2027 19.2445 11.2027C18.5605 11.2027 17.9496 11.4484 17.9496 12.1324V14.118H20.752Z",
    fill: "#0069CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebbokIcon);
export default __webpack_public_path__ + "static/media/facebbok-icon.29f34b5b67bc5c18cdae613ad3b8c0f0.svg";
export { ForwardRef as ReactComponent };